module.exports = __webpack_public_path__ + "static/media/rubyBGDesktop.ad3433ec.webp";